module.exports = __webpack_public_path__ + "img/product-key-tags.38dffcee.png";